import { buildFileUrl } from "@sanity/asset-utils";
import { Asset } from "sanity";
import { dataset, projectId } from "../env";

const fileUrl = (source: Asset) => {
  return buildFileUrl(source, { projectId, dataset });
};

export default fileUrl;
